import { combineReducers } from 'redux';
import location from './location';

const rootReducer = combineReducers({
  location,
});

export default rootReducer;
